export enum WafRuleSeverityEnum {
  Notice,
  Warning,
  Critical,
}
